import React from "react";
import "./Row.scss";
/**
 * Flex layout in row order.
 *
 * Note that this adds some default margins (10px below Row), alters margins of headings (vertical margin 10px), and spaces children with 5px.
 *
 * ```tsx live
 * <Row>
 *   <button type="button"><Icon name="edit" /> Edit</button>
 *   <button type="button"><Icon name="trash" /> Delete</button>
 *   <Grow />
 *   <button type="button"><Icon name="logout" /> Logout</button>
 * </Row>
 * ```
 */
function Row({ className, align = "center", children }) {
    return (React.createElement("div", { className: `aui-row align-${align} ${className !== null && className !== void 0 ? className : ""}` }, children));
}
export default Row;
